import { render, staticRenderFns } from "./ProfileDetails.vue?vue&type=template&id=80bc52d6&scoped=true"
import script from "./ProfileDetails.vue?vue&type=script&lang=ts"
export * from "./ProfileDetails.vue?vue&type=script&lang=ts"
import style0 from "./ProfileDetails.vue?vue&type=style&index=0&id=80bc52d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc52d6",
  null
  
)

export default component.exports